import { Text, Heading, Modal, CloseButton } from '@smarterservices/smarter-ui';
import { Button } from '@instructure/ui';
import useSessionStore from '../../stores/session';

const EndSessionModal = () => {
  const { setEndSessionSid, endSessionSid, endSession } = useSessionStore();

  return (
    <Modal
      open={endSessionSid?.length}
      onDismiss={() => setEndSessionSid(null)}
      label="End Session"
    >
      <Modal.Header>
        <CloseButton
          placement="end"
          offset="small"
          onClick={() => setEndSessionSid(null)}
          screenReaderLabel="Close"
        />
        <Heading>End Session</Heading>
      </Modal.Header>
      <Modal.Body>
        <Text>Are you sure you want to end {endSessionSid}?</Text>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => endSession()} color="primary">
          Yes, End Session
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EndSessionModal;
